import * as React from 'react'
import styled from 'styled-components'
import Modal from '../../../../common/src/components/Modal'
import { Spacer, H4, IntroTextSpan } from '../../../../common/src/components/core'
import { Fonts, Colors } from '../../../../common/src/constants'
import { TestIds } from '../../../../common/src/data/testids'

export default function ShortcutsModal({ onClose }: Readonly<{ onClose: () => void }>) {
  return (
    <Modal title="Shortcuts" onClose={onClose} width={720} data-testid={TestIds.shortcutsModal}>
      <Spacer height={16} />
      <H4>Navigate</H4>
      <Spacer height={16} />
      <Shortcut label="s" desc="search" />
      <Shortcut label="f" desc="filter showings" />
      <Shortcut label="l" desc="go to lobby" />
      <Shortcut label="t" desc="go to tasks" />
      <Shortcut label="i" desc="go to inbox" />
      <Shortcut label="esc" desc="escape from anywhere&mdash;close popup, close search, cancel edit, etc" />
      <Spacer height={32} />
      <H4>Send messages</H4>
      <Spacer height={16} />
      <Shortcut label="q" desc="quick action" />
      <Shortcut label="m" desc="compose message" />
      <Shortcut label="e" desc="edit message" />
      <Shortcut label="tab, enter" desc="go to the Send button, then click Send" />
      <Spacer height={32} />
      <H4>Manage threads</H4>
      <Spacer height={16} />
      <Shortcut label="y" desc="archive or unarchive" />
      <Shortcut label="1" desc="archive, reactivate after 1 day" />
      <Shortcut label="p" desc="show pricing, floor plans" />
      <Shortcut label="n" desc="edit name" />
      <Shortcut label="j" desc="navigate to next thread in the inbox" />
      <Shortcut label="k" desc="navigate to prev thread in the inbox" />
      <Shortcut label="b" desc="navigate to bottom-most thread in the inbox" />
      <Shortcut label="g" desc="navigate to thread with the least time left" />
      <Shortcut label="shift+v" desc="toggle virtual tour type selection" />
      <Shortcut label="shift+i" desc="toggle in-person tour type selection" />
      <Shortcut label="shift+s" desc="toggle self-guided tour type selection" />
      <Shortcut label="ctrl+0" desc="toggle STUDIO unit type" />
      <Shortcut label="ctrl+1" desc="toggle BR1 unit type" />
      <Shortcut label="ctrl+2" desc="toggle BR2 unit type" />
      <Shortcut label="ctrl+3" desc="toggle BR3 unit type" />
      <Shortcut label="ctrl+4" desc="toggle BR4 unit type" />
      <Shortcut label="ctrl+5" desc="toggle BR5 unit type" />
      <Spacer height={32} />
    </Modal>
  )
}

function Shortcut({ label, desc }: { label: string; desc: string }) {
  return (
    <ShortcutWrap>
      <ShortcutLabel>{label}</ShortcutLabel>
      <IntroTextSpan>{desc}</IntroTextSpan>
    </ShortcutWrap>
  )
}

const ShortcutWrap = styled.div`
  margin-bottom: 5px;
  & span {
    vertical-align: top;
  }
`

const ShortcutLabel = styled.span`
  font-family: ${Fonts.mono};
  display: inline-block;
  width: 75px;
  color: ${Colors.white};
  vertical-align: -20% !important;
`
